<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>

  <div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="heading mb-0">Leads Reports</h5>
        <div class="d-flex gap-2 align-items-center" *ngIf="checkDownloadPermission">
          <button
            class="btn btn-outline-danger btn-sm"
            (click)="downloadReport('pdf')"
            [disabled]="isDownloading">
            <span *ngIf="isDownloading && activeDownloadType === 'pdf'" class="spinner-border spinner-border-sm me-1"></span>
            <i class="bi bi-file-earmark-pdf me-1" *ngIf="!isDownloading || activeDownloadType !== 'pdf'"></i>
            PDF
          </button>
          <button
            class="btn btn-outline-success btn-sm"
            (click)="downloadReport('csv')"
            [disabled]="isDownloading">
            <span *ngIf="isDownloading && activeDownloadType === 'csv'" class="spinner-border spinner-border-sm me-1"></span>
            <i class="bi bi-file-earmark-spreadsheet me-1" *ngIf="!isDownloading || activeDownloadType !== 'csv'"></i>
            CSV
          </button>
          <button
            class="btn btn-outline-primary btn-sm"
            (click)="openShareModal('email')"
            [disabled]="isDownloading">
            <i class="bi bi-envelope me-1"></i> Email
          </button>
          <button
            class="btn btn-outline-success btn-sm"
            (click)="openShareModal('whatsapp')"
            [disabled]="isDownloading">
            <i class="bi bi-whatsapp me-1"></i> WhatsApp
          </button>
          <span *ngIf="isDownloading" class="text-muted small ms-2">{{ downloadProgress }}</span>
        </div>
      </div>

      <!-- Filters -->
      <form [formGroup]="filterForm">
        <div class="row g-2 mb-3">
          <div class="col-md-2 col-sm-6">
            <label class="form-label">Start Date</label>
            <input type="date" class="form-control form-control-sm" formControlName="start_date" (change)="onFilterChange()">
          </div>
          <div class="col-md-2 col-sm-6">
            <label class="form-label">End Date</label>
            <input type="date" class="form-control form-control-sm" formControlName="end_date"
              [min]="filterForm.get('start_date')?.value" (change)="onFilterChange()">
          </div>
          <div class="col-md-2 col-sm-6">
            <label class="form-label">Stage</label>
            <ng-select
              formControlName="stage"
              [items]="stageOptions"
              bindLabel="label"
              bindValue="value"
              placeholder="All"
              (change)="onFilterChange()"
              (clear)="onFilterChange()"
              class="select2-sm">
            </ng-select>
          </div>
          <div class="col-md-2 col-sm-6">
            <label class="form-label">Status</label>
            <ng-select
              formControlName="status"
              [items]="statusOptions"
              bindLabel="label"
              bindValue="value"
              placeholder="All"
              (change)="onFilterChange()"
              (clear)="onFilterChange()"
              class="select2-sm">
            </ng-select>
          </div>
          <div class="col-md-2 col-sm-6">
            <label class="form-label">Source</label>
            <ng-select
              formControlName="source"
              [items]="sourceOptions"
              bindLabel="label"
              bindValue="value"
              placeholder="All"
              (change)="onFilterChange()"
              (clear)="onFilterChange()"
              class="select2-sm">
            </ng-select>
          </div>
          <div class="col-md-2 col-sm-6">
            <label class="form-label">Assigned To</label>
            <ng-select
              formControlName="assigned_to"
              [items]="managersItems"
              bindLabel="label"
              bindValue="value"
              placeholder="All Users"
              [virtualScroll]="true"
              (scrollToEnd)="onManagerScrollEnd()"
              (search)="searchManager$.next($event.term)"
              (change)="onFilterChange()"
              (clear)="onFilterChange()"
              class="select2-sm">
            </ng-select>
          </div>
          <div class="col-md-2 col-sm-6 d-flex align-items-end">
            <button class="btn btn-outline-secondary btn-sm w-100" (click)="resetFilters()" [disabled]="!disableClear">
              Clear
            </button>
          </div>
        </div>
      </form>

      <!-- Summary Cards -->
      <div class="d-flex flex-wrap gap-2 mb-3" *ngIf="summaryData">
        <div class="summary-card bg-primary text-white">
          <div class="summary-value">{{ summaryData.total_leads }}</div>
          <div class="summary-label">Total Leads</div>
        </div>
        <div class="summary-card bg-success text-white" *ngIf="summaryData.count_by_status?.['Token Amount Paid'] !== undefined">
          <div class="summary-value">{{ summaryData.count_by_status['Token Amount Paid'] || 0 }}</div>
          <div class="summary-label">Token Paid</div>
        </div>
        <div class="summary-card bg-warning text-dark" *ngIf="summaryData.count_by_status?.['New'] !== undefined">
          <div class="summary-value">{{ summaryData.count_by_status['New'] || 0 }}</div>
          <div class="summary-label">New</div>
        </div>
        <div class="summary-card bg-info text-dark" *ngIf="summaryData.count_by_status?.['Reached Out'] !== undefined">
          <div class="summary-value">{{ summaryData.count_by_status['Reached Out'] || 0 }}</div>
          <div class="summary-label">Reached Out</div>
        </div>
        <div class="summary-card bg-secondary text-white" *ngIf="summaryData.count_by_status?.['Final Agreement Signed'] !== undefined">
          <div class="summary-value">{{ summaryData.count_by_status['Final Agreement Signed'] || 0 }}</div>
          <div class="summary-label">Agreement Signed</div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="d-flex justify-content-between align-items-end">
        <ul class="nav nav-tabs mb-0 flex-grow-1">
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'all'" (click)="switchTab('all')" href="javascript:void(0)">All Leads</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'by-status'" (click)="switchTab('by-status')" href="javascript:void(0)">By Status</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'by-source'" (click)="switchTab('by-source')" href="javascript:void(0)">By Source</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'graphs'" (click)="switchTab('graphs')" href="javascript:void(0)">Graphs</a>
          </li>
        </ul>
        <div class="dropdown mb-1 ms-2" *ngIf="activeTab === 'all' && availableColumns.length"
            (click)="$event.stopPropagation()">
          <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button"
              (click)="toggleColumnPicker()">
            <i class="bi bi-columns me-1"></i> Columns
          </button>
          <ul class="dropdown-menu dropdown-menu-end p-2 shadow" style="min-width: 220px;"
              [class.show]="showColumnPicker">
            <li *ngFor="let col of availableColumns" class="form-check">
              <input class="form-check-input" type="checkbox"
                  [id]="'lead-col-' + col.key"
                  [checked]="selectedColumnKeys.has(col.key)"
                  (change)="toggleColumn(col.key, $any($event.target).checked)">
              <label class="form-check-label" [for]="'lead-col-' + col.key">{{ col.label }}</label>
            </li>
          </ul>
        </div>
      </div>

      <!-- Tab Content -->
      <div class="tab-content">

        <!-- All Leads Tab -->
        <div class="tab-pane" [class.active]="activeTab === 'all'">
          <div class="table-responsive">
            <table class="table table-hover table-sm mt-2">
              <thead>
                <tr>
                  <th *ngFor="let col of visibleColumns">{{ col.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let lead of allLeadsData">
                  <td *ngFor="let col of visibleColumns" [class.report-wrap-cell]="col.wrap">
                    <ng-container [ngSwitch]="col.key">
                      <span *ngSwitchCase="'source'" class="badge" [ngClass]="getSourceClass(lead.source)">{{ lead.source }}</span>
                      <span *ngSwitchCase="'status'" class="badge" [ngClass]="getStatusClass(lead.status)">{{ lead.status }}</span>
                      <ng-container *ngSwitchCase="'follow_up_date'">{{ $any(lead)[col.key] || '-' }}</ng-container>
                      <ng-container *ngSwitchCase="'created_at'">{{ $any(lead)[col.key] || '-' }}</ng-container>
                      <div *ngSwitchDefault [class.report-wrap-content]="col.wrap">{{ $any(lead)[col.key] || '-' }}</div>
                    </ng-container>
                  </td>
                </tr>
                <tr *ngIf="allLeadsData.length === 0">
                  <td [attr.colspan]="visibleColumns.length || 1" class="text-center text-muted py-3">No leads found</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="dataTables_paginate" *ngIf="pageCountAll > 1">
            <app-pagination [totalPage]="pageCountAll" [page]="pageAll" (newPage)="pageChangeAll($event)"></app-pagination>
          </div>
        </div>

        <!-- By Status Tab -->
        <div class="tab-pane" [class.active]="activeTab === 'by-status'">
          <div class="table-responsive">
            <table class="table table-hover table-sm mt-2">
              <thead>
                <tr>
                  <th>Status</th>
                  <th class="text-end">Total Leads</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of byStatusData">
                  <td><span class="badge" [ngClass]="getStatusClass(row.status)">{{ row.status }}</span></td>
                  <td class="text-end">{{ row.total }}</td>
                </tr>
                <tr *ngIf="byStatusData.length === 0">
                  <td colspan="2" class="text-center text-muted py-3">No data found</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="dataTables_paginate" *ngIf="pageCountByStatus > 1">
            <app-pagination [totalPage]="pageCountByStatus" [page]="pageByStatus" (newPage)="pageChangeByStatus($event)"></app-pagination>
          </div>
        </div>

        <!-- By Source Tab -->
        <div class="tab-pane" [class.active]="activeTab === 'by-source'">
          <div class="table-responsive">
            <table class="table table-hover table-sm mt-2">
              <thead>
                <tr>
                  <th>Source</th>
                  <th class="text-end">Total Leads</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of bySourceData">
                  <td><span class="badge" [ngClass]="getSourceClass(row.source)">{{ row.source }}</span></td>
                  <td class="text-end">{{ row.total }}</td>
                </tr>
                <tr *ngIf="bySourceData.length === 0">
                  <td colspan="2" class="text-center text-muted py-3">No data found</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="dataTables_paginate" *ngIf="pageCountBySource > 1">
            <app-pagination [totalPage]="pageCountBySource" [page]="pageBySource" (newPage)="pageChangeBySource($event)"></app-pagination>
          </div>
        </div>

        <!-- Graphs Tab -->
        <div class="tab-pane" [class.active]="activeTab === 'graphs'">
          <div class="row mt-3" *ngIf="summaryData">
            <!-- Leads by Status Chart -->
            <div class="col-md-6 mb-3">
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">Leads by Status</h5>
                </div>
                <div class="card-body chart-container">
                  <div class="chart-bars">
                    <div class="chart-bar-item" *ngFor="let key of getSummaryKeys(summaryData.count_by_status)">
                      <span class="chart-bar-label">{{ key }}</span>
                      <div class="chart-bar-wrapper">
                        <div class="chart-bar"
                          [style.width.%]="summaryData.total_leads > 0 ? (summaryData.count_by_status[key] / summaryData.total_leads) * 100 : 0"
                          [ngClass]="{
                            'bg-primary': key === 'New',
                            'bg-info': key === 'Reached Out' || key === 'Introduction Done',
                            'bg-warning': key === 'Draft Agreement Sent' || key === 'Final Agreement Sent',
                            'bg-success': key === 'Final Agreement Signed' || key === 'Token Amount Paid'
                          }">
                        </div>
                        <span class="chart-bar-value">{{ summaryData.count_by_status[key] }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Leads by Source Chart -->
            <div class="col-md-6 mb-3">
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">Leads by Source</h5>
                </div>
                <div class="card-body chart-container">
                  <div class="chart-bars">
                    <div class="chart-bar-item" *ngFor="let key of getSummaryKeys(summaryData.count_by_source)">
                      <span class="chart-bar-label">{{ key }}</span>
                      <div class="chart-bar-wrapper">
                        <div class="chart-bar"
                          [style.width.%]="summaryData.total_leads > 0 ? (summaryData.count_by_source[key] / summaryData.total_leads) * 100 : 0"
                          [ngClass]="getSourceBarClass(key)">
                        </div>
                        <span class="chart-bar-value">{{ summaryData.count_by_source[key] }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!summaryData" class="text-center text-muted py-4">
            No data available for charts
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Share Modal -->
<div class="modal d-block" tabindex="-1" role="dialog" *ngIf="showShareModal" style="background-color: rgba(0,0,0,0.5);">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Share Report via {{ shareType === 'email' ? 'Email' : 'WhatsApp' }}</h5>
        <button type="button" class="btn-close" (click)="closeShareModal()"></button>
      </div>
      <form [formGroup]="shareForm">
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Search User</label>
            <ng-select
              formControlName="selectedUser"
              [items]="managersItems"
              bindLabel="label"
              bindValue="value"
              placeholder="Search by name..."
              (search)="searchManager$.next($event.term)"
              (change)="onShareUserChange($event)"
              class="select2-sm">
            </ng-select>
          </div>
          <div class="row mb-3">
            <div class="col-6">
              <label class="form-label">First Name</label>
              <input type="text" class="form-control form-control-sm" formControlName="first_name" placeholder="First name">
            </div>
            <div class="col-6">
              <label class="form-label">Last Name</label>
              <input type="text" class="form-control form-control-sm" formControlName="last_name" placeholder="Last name">
            </div>
          </div>
          <div class="mb-3" *ngIf="shareType === 'email'">
            <label class="form-label">Email Address</label>
            <input type="email" class="form-control form-control-sm" formControlName="email" placeholder="Enter email">
          </div>
          <div class="mb-3" *ngIf="shareType === 'whatsapp'">
            <div class="row">
              <div class="col-4">
                <label class="form-label">Code</label>
                <input type="text" class="form-control form-control-sm" formControlName="country_code" placeholder="+91">
              </div>
              <div class="col-8">
                <label class="form-label">WhatsApp Number</label>
                <input type="text" class="form-control form-control-sm" formControlName="whatsapp" placeholder="Enter number">
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">File Type</label>
            <ng-select
              formControlName="file_type"
              [items]="reportTypeOptions"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              class="select2-sm">
            </ng-select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-sm" (click)="closeShareModal()">Cancel</button>
          <button type="button" class="btn btn-primary btn-sm" (click)="submitShare()">
            <i class="bi" [ngClass]="{'bi-envelope': shareType === 'email', 'bi-whatsapp': shareType === 'whatsapp'}"></i>
            Send
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
</div>
